<template>
  <div v-if="state != 0 || state != 2" class="alert alert-danger">
    <div class="row">
      <div class="col-12">
        <form class="d-flex justify-content-center">
          <div class="mb-2" style="margin-top: 0.1em">
            <h4>
              <b class="badge badge-light p-2 noselect">{{ securityCode }}</b>
            </h4>
          </div>
          <div class="form-group mb-2">
            <input
              v-model="inputSecurityCode"
              type="text"
              class="form-control ml-2"
              placeholder="Código de seguridad"
            />
          </div>
        </form>
      </div>
      <div v-if="!loadChangeState" class="col-md-6 col-12 my-1">
        <div v-if="state != 4">
          <span
            @click="handleInactivePublication"
            class="btn btn-warning btn-block"
            >Pausar publicación</span
          >
        </div>
        <div v-else>
          <span
            @click="handleActivePublication"
            class="btn btn-success btn-block"
            >Activar publicación</span
          >
        </div>
      </div>
      <div v-if="!loadChangeState" class="col-md-6 col-12 my-1">
        <span class="btn btn-danger btn-block" @click="handleDeletePublication"
          >Eliminar publicación</span
        >
      </div>
      <div v-if="loadChangeState" class="col-12">
        <span class="btn btn-block btn-treid">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        </span>
      </div>
    </div>
    <p v-if="showWrongCode" class="text-center mt-4 mb-0">
      Codigo de seguirdad incorrecto
    </p>
  </div>
</template>

<script>
import Api from "../../tools/Api2";
import { PRODUCT_CONSTANT } from "../../configs/contants";
export default {
  name: "StatePublication",
  props: {
    state: {
      type: Number,
      default: 0,
    },
    id: {
      type: String,
      default: "",
    },
    kind: {
      type: String,
      default: "producto",
    },
  },
  data() {
    return {
      securityCode: 0,
      inputSecurityCode: "",
      loadChangeState: false,
      showWrongCode: false,
    };
  },
  created: function () {
    this.securityCode = Math.random(2).toString().slice(2, 7);
  },
  methods: {
    handleInactivePublication() {
      if (this.securityCode != this.inputSecurityCode)
        return (this.showWrongCode = true);

      this.loadChangeState = true;
      Api(this.kind == "producto" ? "product" : "service")
        .patch(this.id, { state: PRODUCT_CONSTANT.STATE.INACTIVE })
        .then(() => {
          this.loadChangeState = false;
          this.$router.push({ name: "Publications" });
        });
    },
    handleDeletePublication() {
      if (this.securityCode != this.inputSecurityCode)
        return (this.showWrongCode = true);

      this.loadChangeState = true;
      Api(this.kind == "producto" ? "product" : "service")
        .patch(this.id, { state: PRODUCT_CONSTANT.STATE.DELETE })
        .then(() => {
          this.loadChangeState = false;
          this.$router.push({ name: "Publications" });
        });
    },
    handleActivePublication() {
      if (this.securityCode != this.inputSecurityCode)
        return (this.showWrongCode = true);

      this.loadChangeState = true;
      Api(this.kind == "producto" ? "product" : "service")
        .patch(this.id, { state: PRODUCT_CONSTANT.STATE.ACTIVE })
        .then(() => {
          this.loadChangeState = false;
          this.$router.push({ name: "Publications" });
        });
    },
  },
};
</script>

<style>
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
} 
</style>